import ScoreBadminton from "./ScoreBadminton";
export default ScoreBadminton;
